let context;
const offsets = new Map();

// Measure once per glyph/font, after the caller has waited for fonts to load.
export const getInitialBaselineOffset = (initial, font) => {
  const key = `${font}:${initial}`;
  if (!offsets.has(key)) {
    context ||= document.createElement('canvas').getContext('2d');
    context.font = font;
    const metrics = context.measureText(initial);
    offsets.set(
      key,
      (metrics.actualBoundingBoxAscent - metrics.actualBoundingBoxDescent) / 2
    );
  }
  return offsets.get(key);
};
